module.exports = __webpack_public_path__ + "static/media/traffic-event.842f603e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wcce/traffic-event.svg
// module id = 970
// module chunks = 0